<template>
  <v-dialog v-model="dialog" max-width="560" class="eqwo-feedback-dialog">
    <v-card>
      <v-card-title :class="titleClass">
        <v-icon left dark>{{ iconName }}</v-icon>
        {{ feedback.title }}
      </v-card-title>

      <v-card-text class="pt-4">
        <p class="eqwo-feedback-message">{{ feedback.message }}</p>
        <p v-if="feedback.hint" class="eqwo-feedback-hint">{{ feedback.hint }}</p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="buttonColor" depressed @click="dialog = false">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EqwoFeedbackDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    feedback: {
      type: Object,
      default: () => ({
        type: "success",
        title: "",
        message: "",
        hint: null,
      }),
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isSuccess() {
      return this.feedback.type === "success";
    },
    titleClass() {
      return this.isSuccess
        ? "headline success white--text"
        : "headline error white--text";
    },
    iconName() {
      return this.isSuccess ? "mdi-check-circle" : "mdi-alert-circle";
    },
    buttonColor() {
      return this.isSuccess ? "success" : "primary";
    },
  },
};
</script>

<style scoped>
.eqwo-feedback-dialog .v-card__title.success {
  background-color: #4caf50;
}

.eqwo-feedback-dialog .v-card__title.error {
  background-color: #f44336;
}

.eqwo-feedback-message {
  font-size: 1.05rem;
  line-height: 1.5;
  margin: 0;
}

.eqwo-feedback-hint {
  font-size: 0.95rem;
  line-height: 1.45;
  color: #666;
  margin: 12px 0 0;
}
</style>
